/* Buy 1 Get 4 Free Gifts + $10 off.
   PDP: the add-to-bag buttons on the offer product also add the 4 chosen gifts.
   Bag drawer: labels gift lines, shows the offer banner, and removes gifts if the offer item leaves the bag. */
(function () {
  var OFFER_PRODUCT = 10940293152927;
  var GIFT_PRODUCTS = [10940293218463, 10940293251231, 10940293283999];
  var GIFT_PROP = "_ylb_gift";

  var css = document.createElement("style");
  css.textContent =
    ".ylbo-banner{margin:0 0 6px;padding:12px 14px;border-radius:12px;background:rgba(160,122,47,.12);font-size:14px;font-weight:700;text-align:center;line-height:1.35}" +
    ".ylbo-banner em{font-style:normal;color:var(--foil-ink,#a07a2f)}" +
    ".line.ylbo-gift{display:none!important}" + ".ylbo-strip{padding:10px 0 12px;border-bottom:1px solid rgba(127,127,127,.2)}" + ".ylbo-sh{display:flex;justify-content:space-between;font-size:13px;margin-bottom:8px}.ylbo-sh span{color:var(--foil-ink,#a07a2f);font-weight:800}" + ".ylbo-track{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}.ylbo-track::-webkit-scrollbar{display:none}" + ".ylbo-chip{flex:0 0 64px;scroll-snap-align:start;display:grid;gap:4px;text-align:center;font-size:10px;line-height:1.2}.ylbo-chip img{width:64px;height:64px;object-fit:cover;border-radius:10px;display:block}" +
    ".ylbo-badge{display:inline-block;margin-top:6px;font-size:10px;font-weight:800;letter-spacing:.08em;padding:3px 8px;border-radius:999px;background:var(--foil-ink,#a07a2f);color:#fff}" +
    ".line.ylbo-gift .r .num{color:var(--foil-ink,#a07a2f);font-weight:700}" +
    ".ylbo-save{display:flex;justify-content:space-between;font-size:14px;color:var(--foil-ink,#a07a2f);font-weight:700;margin-bottom:6px}";
  document.head.appendChild(css);

  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function money(c) { var n = c / 100; return "$" + (Number.isInteger(n) ? n : n.toFixed(2)); }
  function isGift(item) { return GIFT_PRODUCTS.indexOf(item.product_id) > -1; }
  function isOffer(item) { return item.product_id === OFFER_PRODUCT; }

  /* ---------- PDP: add main item + gifts ---------- */
  var box = document.getElementById("ylbOffer");
  if (box) {
    box.addEventListener("change", function (e) {
      var s = e.target.closest("[data-gift-select]");
      if (!s) return;
      var opt = s.options[s.selectedIndex];
      var img = document.getElementById("ylbGiftImg" + s.id.replace("ylbGift", ""));
      if (img && opt && opt.dataset.img) img.src = opt.dataset.img;
    });

    Array.prototype.forEach.call(box.querySelectorAll("select[data-gift-select]"), function (s) { var o = s.options[s.selectedIndex]; var img = document.getElementById("ylbGiftImg" + s.id.replace("ylbGift", "")); if (img && o && o.dataset.img) img.src = o.dataset.img; });

    var busy = false;
    window.addEventListener("click", function (e) {
      var btn = e.target.closest("#pdpAtc, #pdpStickyAtc");
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      busy = true;

      var pressed = document.querySelector("#pdp [data-variant][aria-pressed='true']");
      var mainId = pressed ? Number(pressed.dataset.variant) : null;
      if (!mainId) {
        try {
          var vs = JSON.parse(document.getElementById("pdpVariants").textContent);
          var v = vs.filter(function (x) { return x.available; })[0] || vs[0];
          mainId = v && v.id;
        } catch (err) {}
      }
      var gifts = Array.prototype.map.call(box.querySelectorAll("[data-gift-select]"), function (s) { return Number(s.value); });

      getCart().then(function (cart) {
        var hasGifts = cart.items.some(isGift);
        if (hasGifts || !gifts.length) return;
        var items = gifts.map(function (id) { var p = {}; p[GIFT_PROP] = "Free gift"; return { id: id, quantity: 1, properties: p }; });
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) });
      }).then(function () {
        if (window.ylbAdd) return window.ylbAdd(mainId, 1);
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: mainId, quantity: 1 }] }) })
          .then(function () { window.location.href = "/cart"; });
      }).catch(function () {
        if (window.ylbToast) window.ylbToast("Something went wrong, please try again");
      }).then(function () { busy = false; });
    }, true);
  }

  /* ---------- Bag drawer: decorate + keep gifts in sync ---------- */
  var lines = document.getElementById("lines");
  var foot = document.getElementById("df");
  if (!lines) return;

  var painting = false, dirty = false;
  function decorate() {
    if (painting) { dirty = true; return; }
    painting = true; dirty = false;
    getCart().then(function (cart) {
      var hasOffer = cart.items.some(isOffer);
      var giftItems = cart.items.filter(isGift);

      if (!hasOffer && giftItems.length) {
        var updates = {};
        giftItems.forEach(function (i) { updates[i.key] = 0; });
        return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ updates: updates }) })
          .then(function () { var b = document.getElementById("bagOpen"); if (b) b.click(); });
      }

      var rows = lines.querySelectorAll(".line"), offerRow = null;
      cart.items.forEach(function (item, i) {
        var row = rows[i]; if (!row) return;
        if (isGift(item)) row.classList.add("ylbo-gift");
        if (isOffer(item)) offerRow = row;
      });
      var oldStrip = lines.querySelector(".ylbo-strip"); if (oldStrip) oldStrip.remove();
      if (giftItems.length && offerRow) {
        var chips = giftItems.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : "";
          return '<div class="ylbo-chip"><img src="' + img + '" alt="" width="64" height="64" loading="lazy"><span>' + (it.variant_title || "") + "</span></div>";
        }).join("");
        offerRow.insertAdjacentHTML("afterend", '<div class="ylbo-strip"><div class="ylbo-sh"><b>' + giftItems.length + ' free gifts</b><span>FREE</span></div><div class="ylbo-track">' + chips + "</div></div>");
      }

      if (hasOffer && !lines.querySelector(".ylbo-banner")) {
        lines.insertAdjacentHTML("afterbegin", '<div class="ylbo-banner">🎉 You unlocked <em>4 free gifts</em> + <em>an extra $10 off</em></div>');
      }
      var saved = cart.original_total_price - cart.total_price;
      if (hasOffer && foot && saved > 0 && !foot.querySelector(".ylbo-save")) {
        foot.insertAdjacentHTML("afterbegin", '<div class="ylbo-save"><span>You saved</span><span>' + money(saved) + "</span></div>");
      }
    }).catch(function () {}).then(function () { painting = false; if (dirty) decorate(); });
  }

  new MutationObserver(function () { decorate(); }).observe(lines, { childList: true });
})();
